module.exports = __webpack_public_path__ + "static/media/SashaObucinaResume-Final.4c162176.pdf";